<template>
  <div class="jin-list">
    <Common @change="onChange" />
    <JinPc />
    <JinM />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Common from './page/common'
import JinPc from './page/pc'
import JinM from './page/mobile'
import shareApp from '@/utils/wechat.share'

export default {
  components: {
    JinPc,
    JinM,
    Common
  },
  data() {
    return {
    }
  },
  computed: {
    ...mapGetters([
      'category'
    ]),
    attributes() {
      return this.$route.query.attributes
    }
  },
  watch: {
    attributes() {
      this.GET_CATEGORY()
    }
  },
  mounted() {
    this.init()
    shareApp.wechat('金十招聘', '', '快来加入我们吧!')
  },
  methods: {
    ...mapActions('position', ['GET_CATEGORY', 'GET_LIST']),
    async init() {
      if (!(this.category && this.category.length)) await this.GET_CATEGORY()
    },
    onChange(key) {
    }
  }
}
</script>

<style lang="scss" scoped>

@media only screen and (min-width: 769px) {
  .jin-list {
    background: #f4f5f9;
    padding-top: $tabHeight;
    min-height: $bodyHeight;
  }
}
</style>
